<template>
  <div class="password">
    <ui-title :title="t('forgot.create')" :wave="'/authTitleBg.png'" />
    <div class="container">
      <div class="password__wrapper">
        <new-password-form />
        <img class="password__wave" src="@images/authWave.png" alt="wave">
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UiTitle from "@/components/ui/ui-title.vue";
import NewPasswordForm from "@/components/forms/new-password-form.vue";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.password {
  top: -103px;
  background-color: $white;
  position: relative;

  &__wrapper {
    padding-block: 100px;
  }

  &__wave {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>